import { Button, Flex } from 'antd'
import { useTranslation } from 'react-i18next'
import type { AdCampaign } from '@/features/portal/api'
import { StepHeader } from '@/shared/ui/StepHeader'

interface AdChooseStepProps {
  campaigns: AdCampaign[]
  onChoose: (campaign: AdCampaign) => void
}

/**
 * Bir nechta kampaniya bo'lsa — mehmon tanlaydi. Bitta bo'lsa, bu ekran
 * umuman ko'rsatilmaydi (`PortalPage` avtomatik tanlaydi) — vazifaning
 * "bitta ekranda bitta qadam" talabi ortiqcha tanlovni yo'qotadi.
 */
export function AdChooseStep({ campaigns, onChoose }: AdChooseStepProps) {
  const { t } = useTranslation()

  return (
    <Flex vertical gap={16}>
      <StepHeader title={t('ad.chooseTitle')} />
      <Flex vertical gap={10}>
        {campaigns.map((campaign) => (
          <Button key={campaign.id} size="large" block onClick={() => onChoose(campaign)}>
            {campaign.name} — {t('ad.by', { name: campaign.advertiserName })}
          </Button>
        ))}
      </Flex>
    </Flex>
  )
}
